export const SourceAircraftUtilization = "aircraftutilizations";

export const TitleAircraftUtilization = {
  list: "Aircraft Utilization List",
  edit: "Edit Aircraft Utilization ",
  create: "Create Aircraft Utilization ",
};
